import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { AnimatedSection } from "@/components/ui/AnimatedSection";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <SEO
        title="Privacy Policy | TheCloudSEO"
        description="Privacy Policy for TheCloudSEO explaining how we collect, use, and protect your information across our website and services."
        canonical="https://thecloudseo.com/privacy"
      />

      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <AnimatedSection>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Privacy Policy
            </h1>
            <p className="text-muted-foreground mb-12">
              Last updated: January 2026
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <div className="space-y-10 text-lg leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  1. Introduction
                </h2>
                <p className="text-muted-foreground">
                  At TheCloudSEO, your privacy is important to us. This Privacy
                  Policy explains how we collect, use, disclose, and safeguard
                  your information when you visit our website or engage with
                  our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  2. Information We Collect
                </h2>
                <p className="text-muted-foreground mb-3">
                  We may collect the following types of information:
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Personal details such as name, email address, and company name</li>
                  <li>Information submitted through contact or audit forms</li>
                  <li>Usage data such as pages visited and interaction patterns</li>
                  <li>Technical data including browser type and device information</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  3. How We Use Your Information
                </h2>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>To respond to inquiries and provide requested services</li>
                  <li>To improve our website, services, and user experience</li>
                  <li>To communicate updates, insights, or service-related information</li>
                  <li>To analyze performance and optimize our marketing systems</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  4. Cookies & Tracking Technologies
                </h2>
                <p className="text-muted-foreground">
                  We may use cookies and similar tracking technologies to
                  understand how visitors interact with our site. You can
                  control cookie preferences through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  5. Data Sharing & Disclosure
                </h2>
                <p className="text-muted-foreground">
                  We do not sell, trade, or rent your personal information.
                  Data may be shared only with trusted service providers
                  assisting in website operations, analytics, or communication,
                  under strict confidentiality agreements.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  6. Data Security
                </h2>
                <p className="text-muted-foreground">
                  We implement reasonable technical and organizational measures
                  to protect your information. However, no method of
                  transmission over the internet is completely secure.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  7. Your Rights
                </h2>
                <p className="text-muted-foreground">
                  Depending on your location, you may have rights regarding
                  access, correction, or deletion of your personal data. You
                  may contact us to exercise these rights.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  8. Third-Party Links
                </h2>
                <p className="text-muted-foreground">
                  Our website may contain links to third-party websites. We are
                  not responsible for the privacy practices or content of those
                  sites.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  9. Policy Updates
                </h2>
                <p className="text-muted-foreground">
                  We may update this Privacy Policy periodically. Any changes
                  will be reflected on this page with an updated revision date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  10. Contact Us
                </h2>
                <p className="text-muted-foreground">
                  If you have questions about this Privacy Policy or our data
                  practices, you can contact us at:
                </p>
                <p className="text-muted-foreground mt-2">
                  <strong>Email:</strong> hello@thecloudseo.com
                </p>
              </section>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;